<template>
  <div class="flex items-center">
    <div class="flex items-center justify-center margin-r-2" style="height: 35px; width: 35px; border-radius: 100%; background-color: #e3e3e3;">
      <i class="fa fa-file-invoice"></i>
    </div>
    <div class="flex-1">
      <div v-if="booking.invoice">
        <h3>Your Invoice</h3>
        <span>{{ booking.invoice.created_at | date }}</span>
      </div>
      <div class="flex flex-col" v-else>
        <h3>Your invoice will appear here</h3>
        <span>Your invoice will appear here 1-2 days after booking</span>
      </div>
    </div>
    <ladda-button
      v-if="booking.invoice"
      type="submit"
      class="btn btn-primary btn-sm"
      :click="viewInvoice"
    >
      View Invoice
    </ladda-button>
  </div>
</template>

<script>
import { http, notify } from 'utils'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  methods: {
    async viewInvoice () {
      try {
        const response = await http.get(`bookings/${this.booking.id}/invoice`)
        const invoiceUrl = this.getInvoiceUrl(response.data)

        this.trackEvent(this.analytics.V2.JobPaymentInvoiceClickEvent)

        window.open(invoiceUrl, '_blank')
      } catch (e) {
        notify.error('Sorry something loading your invoice, please try again.')
      }
    },

    getInvoiceUrl (invoice) {
      if (invoice && invoice.file_name) {
        return invoice.file_url
      }
      return null
    }
  }
}
</script>
